import React, { useMemo } from "react";
import { Spin } from "antd";
import Moment from "moment";
import { useHistory } from "react-router-dom";
import {
  Container,
  Heading,
  TitleText,
  TitleMark,
  TextContainer,
  Grid,
  Card,
  CardImage,
  Badge,
  CardBody,
  CardTitle,
  CardSummary,
  CardFooter,
  MoreButton,
  EmptyState,
} from "./styles";
import useFetch from "hooks/useFetch";
import { getAllCoursesBuy } from "services/course";
import CoursePlaceholder from "assets/images/coursePlaceholder.png";

const getBadge = (course) => {
  if (!course.fg_ativo) return null;
  if (Moment(new Date()).isBefore(course.dt_inicio)) {
    return {
      text: `A partir de ${Moment(course.dt_inicio).format("DD/MM/YYYY")}`,
      variant: "primary",
    };
  }
  if (Moment(new Date()).isAfter(course.dt_fim)) {
    return { text: "Inscrições encerradas", variant: "error" };
  }
  return null;
};

const Courses = () => {
  const history = useHistory();
  const [{ data, isFetching }] = useFetch(getAllCoursesBuy, null, true, []);

  const cards = useMemo(() => {
    return data.map((course) => {
      const badge = getBadge(course);
      const goToDetail = () =>
        history.push(`/course-public-detail/${course.id}`);

      return (
        <Card key={course.id} onClick={goToDetail}>
          <CardImage image={course.ds_imagem || CoursePlaceholder}>
            {badge && <Badge variant={badge.variant}>{badge.text}</Badge>}
          </CardImage>
          <CardBody>
            <CardTitle>{course.ds_titulo}</CardTitle>
            <CardSummary>{course.ds_resumo}</CardSummary>
          </CardBody>
          <CardFooter>
            <MoreButton
              onClick={(e) => {
                e.stopPropagation();
                goToDetail();
              }}
            >
              Saiba mais
            </MoreButton>
          </CardFooter>
        </Card>
      );
    });
  }, [data, history]);

  return (
    <Container>
      <Heading>
        <TitleText>
          Nossos <span>Cursos</span>
        </TitleText>
        <TitleMark />
        <TextContainer>
          Expanda seus conhecimentos sobre a Igreja Católica, Teologia, Bíblia,
          Pastorais e Movimentos e muito mais! Formações práticas que ajudarão
          no dia a dia da sua vida na comunidade.
        </TextContainer>
      </Heading>

      {isFetching ? (
        <EmptyState>
          <Spin />
        </EmptyState>
      ) : data.length ? (
        <Grid>{cards}</Grid>
      ) : (
        <EmptyState>Nenhum curso disponível no momento.</EmptyState>
      )}
    </Container>
  );
};

export default Courses;
